//load our custom elements
require("component-leaflet-map");
require("component-responsive-frame");

//get access to Leaflet and the map
var element = document.querySelector("leaflet-map");
var L = element.leaflet;
var map = element.map;

var data = require("./country-shapes.geo.json");
var dots = require("./points.geo.json");

//ICH code for popup template if needed----------
var ich = require("icanhaz");
var templateFile = require("./_popup.html");
ich.addTemplate("popup", templateFile);

var refugeeMap = {};

var byName = {};

data.features.forEach(function(feature) {
  if (feature.properties && feature.properties.NAME) {
    var name = feature.properties.NAME;
    if (!byName[name]) byName[name] = [];
    byName[name].push(feature.properties);
  }
});



function highlightFeature(e) {
  var layer = e.target;
  layer.setStyle({
    fillOpacity: 0.7
  });
  if (!L.Browser.ie && !L.Browser.opera) {
    layer.bringToFront();
  }
}


function resetHighlight(e) {
  dots.resetStyle(e.target);
}


var onEachFeature = function(feature, layer) {
  layer.on({
    mouseover: highlightFeature,
    mouseout: resetHighlight
  })
  layer.bindPopup(ich.popup(feature.properties));
  if (feature.properties.NAME) {
    refugeeMap[feature.properties.NAME] = layer;
  }
};

function highlightdot(e) {
  var layer2 = e.target;
  var getname = layer2.feature.properties.NAME;
  var layer = refugeeMap[getname];
  if (!layer) return;
  layer.setStyle({
    fillOpacity: 0.7
  })
  // layer.openPopup();

}

function clickdot(e) {
  var layer2 = e.target;
  var getname = layer2.feature.properties.NAME;
  var layer = refugeeMap[getname];
  if (!layer) return;
  layer.openPopup();

}

function resetdot(e) {
  var layer2 = e.target;
  var getname = layer2.feature.properties.NAME;
  var layer = refugeeMap[getname];
  if (!layer) return;
  layer.setStyle({
    fillOpacity: 0.4
  })
}

var onEachFeature2 = function(feature, layer) {

  layer.on({
    mouseover: highlightdot,
    mouseout: resetdot,
    click: clickdot
  })

};

map.scrollWheelZoom.disable();

var geojson = L.geoJson(data, {
  onEachFeature: onEachFeature2,
  style: function(feature) {
    return {
      fillColor: "#5CA2D1",
      weight: 1,
      opacity: 1,
      color: 'white',
      fillOpacity: 0.4
    };
  }

}).addTo(map);

function getSize(d) {
  return d > 600 ? 40 :
    d > 300 ? 32 :
    d > 100 ? 24 :
    d > 30 ? 16 :
    d >= 10 ? 8 :
    1;

}

function style(feature) {
  return {
    radius: getSize(feature.properties.NUMBER),
    fillColor: "#d6301D",
    weight: 0,
    opacity: 1,
    fillOpacity: 0.4
  }
};

var dots = L.geoJson(dots, {
  onEachFeature: onEachFeature,
  style: style,
  pointToLayer: function(feature, latlng) {
    return L.circleMarker(latlng);
  }
}).addTo(map);


map.options.minZoom = 2;